export const excisting_types = [
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ ΟΧΗΜΑΤΟΣ",
  "Γεωργικός Ελκυστήρας",
  "ΜΗΧΑΝΗΜΑ ΕΡΓΟΥ",
  "Τροχόσπιτο",
  "Άλλες περιπτώσεις - Αντίκα",
  "Αντίκα",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ (3,80μ.)",
  "Βάρκα (4 μέτρα)",
  "Βάρκα (4,45 μέτρα)",
  "Βάρκα (χωρητικότητας 5 ατόμων)",
  "Βάρκα 4,95 μέτρα",
  "Βάρκα 5 μέτρων",
  "ΛΕΜΒΟΣ - ΒΑΡΚΑ",
  "Δε συμπληρώθηκε",
  "Δε συμπληρώθηκε από το βουλευτή",
  "Δε συμπληρώθηκε από τον βουλευτή",
  "Δεν έχει δηλωθεί από τον Βουλευτή",
  "Δεν έχει συμπληρωθεί",
  "Δεν έχει συμπληρωθεί από τη βουλευτίνα",
  "Δεν έχει συμπληρωθεί από το βουλευτή",
  "Δεν έχει συμπληρωθεί από τον βουλευτή",
  "Δεν έχει συμπληρωθεί από τον Ευρωβουλευτή",
  "Δεν συμπληρώθηκε",
  "Δεν συμπληρώθηκε από τη βουλευτή",
  "Δεν συμπληρώθηκε από την Βουλευτή",
  "Δεν συμπληρώθηκε από την Βουλευτήνα",
  "Δεν συμπληρώθηκε από την βουλευτίνα",
  "Δεν συμπληρώθηκε από τον βουλευτή",
  "-",
  " ",
  "Eπιβατικό",
  "FIAT PUNTO",
  "IXE",
  "IXE (ακινησία)",
  "ROVER 620",
  "Αυτοκίνητο",
  "Επβατικό",
  "Επιαβτικό",
  "Επιβαατικό",
  "ΕΠΙΒΑΤΙΚΟ",
  "Επιβατικό (ιδιοκτησία Βουλής των Ελλήνων)",
  "Επιβατικό (ιδιοκτησίας Βουλής των Ελλήνων)",
  "Επιβατικό (κατάθεση πινακίδων)",
  "Επιβατικό (Πωλήθηκε)",
  "Επιβατικό (Πώληση)",
  "Επιβατικό (σε ακινησία)",
  "Επιβατικό (φορολογήσιμοι ίπποι)",
  "Επιβατικό 11 Φ. ΊΠΠΟΙ",
  "Επιβατικό από Βουλή των Ελλήνων",
  "ΕΠΙΒΑΤΙΚΟ ΑΠΟ ΚΟΙΝΟΥ ΜΕ ΣΥΖΥΓΟ",
  "Επιβατικό Ι.Χ.",
  "Επιβατικό σε ακινησία από 16/12/2013",
  "Επιβατικό σε ακινησία από 30/12/2009",
  "Επιβατικός",
  "Επιβατικό",
  "ΙΧ",
  "ΙΧΕ",
  "Αγωνιστικό Ιστιοφόρο",
  "ΙΣΤΙΟΦΟΡΟ",
  "Ιστιοφόρο (10 κόροι)",
  "Μοτοποδήλατο",
  "ΔΙΚΥΚΛΟ",
  "ΜΟΤΟΣΥΚΛΕΤΑ",
  "Μοτοσυκλέτα (Εκλάπη το 2014)",
  "Μοτοσυκλέτα (πώληση)",
  "Oυδεμία μεταβολή",
  "Ουδεμία Μεταβολή",
  "Σκάφος αναψυχής",
  "Σκάφος αναψυχής - 8 Άτομα",
  "Σκάφος αναψυχής (10 ατόμων)",
  "Σκάφος αναψυχής (6 μέτρα)",
  "Σκάφος αναψυχής (6-8 άτομα)",
  "Σκάφος αναψυχής (8 άτομα)",
  "Σκάφος αναψυχής (8,30 μέτρα)",
  "Σκάφος αναψυχής (Αγορά 20.000€)",
  "Σκάφος Αναψυχής (φουσκωτό)",
  "Σκάφος Αναψυχής 10 ατόμων",
  "Σκάφος αναψυχής 8,30 μέτρα",
  "Σκάφος Αναψυχής 9 μέτρων",
  "Σκάφος Αναψυχής χωρητικότητας 8 ατόμων",
  "ΤΑΧΥΠΛΟΟ",
  "ΦΟΡΤΗΓΟ",
  "Φορτηγό (Αγροτικό)",
  "Φορτηγό αγροτικό",
  "ΦΟΡΤΗΓΟ Ι.Χ.",
  "0",
  "Κατεστραμένο αρχείο pdf",
  "Το όχημα εκποιήθηκε κατά το τρέχον έτος",
]

export const new_types = [
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΝΤΙΚΑ",
  "ΑΝΤΙΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΒΑΡΚΑ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΕΠΙΒΑΤΙΚΟ",
  "ΙΣΤΙΟΦΟΡΟ",
  "ΙΣΤΙΟΦΟΡΟ",
  "ΙΣΤΙΟΦΟΡΟ",
  "ΜΟΤΟΠΟΔΗΛΑΤΟ",
  "ΜΟΤΟΣΥΚΛΕΤΑ",
  "ΜΟΤΟΣΥΚΛΕΤΑ",
  "ΜΟΤΟΣΥΚΛΕΤΑ",
  "ΜΟΤΟΣΥΚΛΕΤΑ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ",
  "ΦΟΡΤΗΓΟ",
  "ΦΟΡΤΗΓΟ",
  "ΦΟΡΤΗΓΟ",
  "ΦΟΡΤΗΓΟ",
  "",
  "",
  "",
]
